import { CategoryName } from "./Admin";
import Aviation from "./Aviation";
import Electricity from "./Electricity";
import Energies from "./Energies";
import PublicTransport from "./PublicTransport";
import Residues from "./Residues";
import Results from "./Results";
import Users from "./Users";
import Vehicles from "./Vehicles";
import Water from "./Water";

interface CategoryProps {
  category: CategoryName;
}

function Category({ category }: CategoryProps) {
  switch (category) {
    case "users":
      return <Users />;

    case "results":
      return <Results />;

    case "residues":
      return <Residues />;

    case "electricity":
      return <Electricity />;

    case "energies":
      return <Energies />;

    case "water":
      return <Water />;

    case "aviation":
      return <Aviation />;

    case "publicTransport":
      return <PublicTransport />;

    case "vehicles":
      return <Vehicles />;

    default:
      return null;
  }
}

export default Category;
